// extracted by mini-css-extract-plugin
export default {"domainLink":"n2Aj_or"};